<template>
  <div class="app-container">
    <nav class="add-navigation d-flex flex-wrap">
      <div
        @click="$router.push({ name: 'system-admin-company-list' })"
        class="back-link my-2 mr-3"
      >
        <svg
          class="icon"
          width="30px"
          height="30px"
          viewBox="0 0 30 30"
          version="1.1"
        >
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p>Back to Company</p>
      </div>
      <div class="wrapper-buttons d-flex flex-wrap">
        <div
          @click="$router.push({ name: 'system-admin-company-list' })"
          class="secondary-button mr-2"
        >
          <secondary-button>Cancel</secondary-button>
        </div>
        <div>
          <button
            style="background: #51a3f3; border: 1px solid #51a3f3; width: 96%"
            class="btn btn-primary my-2 px-4"
            @click="addManualPayment"
          >
            Submit
          </button>
        </div>
      </div>
    </nav>
    <div class="add-container">
      <span class="container-title">Add Manual Payment</span>
      <div class="col-wrapper">
        <primary-input
          type="number"
          name="amount"
          v-model="company.amount"
          v-validate="'required'"
          :class="{ input: true, 'is-danger': errors.has('amount') }"
          placeholder="Enter amount"
        />
      </div>
      <div class="col-wrapper">
        <div v-if="errors.has('amount')" class="help is-danger">
          {{ errors.first("amount") }}
        </div>
      </div>
      <div class="col-wrapper company-name">
        <span class="balance">{{
          `${balance !== null ? `( Current Balance : ${balance} )` : ""}`
        }}</span>
        <primary-select
          class="company-select"
          name="Company"
          type="text"
          v-model="company.company_uuid"
          placeholder="Select Company"
        >
          <option v-for="(item, i) in companies" :key="i" :value="item.value">
            {{ `${item.name}` }}
          </option>
        </primary-select>
      </div>
      <!-- <div class="col-wrapper">
        <div class="primary-input-container text-area mt-3">
          <p class="primary-input-title">Description</p>
          <div class="text-area-container">
            <textarea
              v-model="company.description"
              v-validate="'required'"
              :class="{'input': true, 'is-danger': errors.has('company.amount')}"
              name="text"
              placeholder="Enter description"
              maxlength="160"
              cols="30"
              rows="7"
            ></textarea>
          </div>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "AddManualPayment",
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    TextArea: () => import("@/components/Inputs/TextArea"),
    // Dropdown: () => import("@/components/DropDowns/Dropdown.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
  },
  data: () => ({
    company: {
      amount: "",
      company_uuid: "",
      // description: "",
    },
    balance: null,
    companies: [],
  }),
  computed: {
    companyName() {
      return this.company.company_uuid;
    },
  },
  watch: {
    companyName(uuid) {
      if (!uuid) {
        this.balance = null;
        return;
      }
      this.$store.dispatch("GetCompany", uuid).then((res) => {
        this.balance = res.balance;
      });
    },
  },
  created() {
    this.getCompanyList();
  },
  methods: {
    transformData(el) {
      return {
        name: el.company_name,
        value: el.company_uuid,
      };
    },
    getCompanyList() {
      this.$store.dispatch("GetCompanyList", {}).then((res) => {
        const { total } = res;

        this.$store
          .dispatch("GetCompanyList", { perPage: total, status: "active" })
          .then((res) => {
            this.companies = res.items.map(this.transformData);
          });
      });
    },
    addManualPayment() {
      if (!this.company.amount || !this.company.company_uuid) {
        this.$snotify.error("Complete fields.", {
          timeout: 6000,
        });
        return;
      }
      this.$store
        .dispatch("AddPayment", {
          amount: this.company.amount,
          company_uuid: this.company.company_uuid,
        })
        .then((res) => {
          this.$router.push({ name: "system-admin-company-list" });
          this.$snotify.success("Company status was changed.", {
            timeout: 6000,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  font-family: "Helvetica Neue";
  padding: 0 20px;
  .pimary-input {
    width: 96%;
  }
  .primary-input-container.text-area {
    width: 100%;
    textarea {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding: 10px 10px 10px 15px;
      border: 1px solid #edeef3;
      border-radius: 4px;
      outline: none;
      font-family: "Helvetica Neue";
      font-size: 14px;
      line-height: 25px;
      resize: none;
    }
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }
  .primary-input-title {
    color: #000000;
    font-family: "Helvetica Neue";
    font-size: 12px;
    font-weight: 900;
    letter-spacing: 0.21px;
    line-height: 15px;
    margin-bottom: 5px;
    text-transform: uppercase;
  }
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;

    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .buttons-wrapper {

      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 140px;
      }
      .secondary-button {
        height: 40px;
        margin-right: 20px;
      }
    }
  }
  .add-container {
    flex-direction: column;
    align-items: center;
    // height: fit-content;
    background-color: #ffffff;
    padding-top: 15px;
    padding-bottom: 100px;

    .company-name {
      position: relative;

      .balance {
        position: absolute;
        top: 29px;
        left: 200px;
        z-index: 5;
        font-size: 14px;
        color: #000;
        pointer-events: none;
      }
      .company-select {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
      }
    }
    .container-title {
      height: 30px;
      width: 432px;
      color: #000000;
      font-size: 16px;
      font-weight: 500;
      line-height: 30px;
      padding: 15px 0 15px 15px;
    }
    .col-wrapper {
      /*width: 100%;*/
      display: flex;
      justify-content: space-between;
      margin-left: 15px;
      margin-right: 15px;
      margin-top: 20px;
      .col {
        width: 100%;
        padding-right: 15px;
        .buttons-wrapper {
          display: flex;
          align-items: center;
          width: fit-content;
          width: 100%;
          .state {
            margin-right: 10px;
          }
          .credit {
            margin-right: 10px;
          }
          .country {
            margin-right: 10px;
          }
        }
        .input {
          margin-bottom: 20px;
        }
        .field {
          p.pimary-input-title {
            color: #000000;
            font-family: "Helvetica Neue";
            font-size: 12px;
            font-weight: 900;
          }
        }
        .upload-photo,
        #dropzone {
          min-height: 285px;
          min-height: 285px;
          border-radius: 4px;
          width: 96%;
          .dz-image {
            padding: 5px;
            img {
              height: 150px;
              width: 150px;
              border-radius: 50px;
            }
          }
        }
        .pimary-input-title {
          color: #000000;
          font-family: "Helvetica Neue";
          font-size: 12px;
          font-weight: 900;
          letter-spacing: 0.21px;
          line-height: 15px;
          margin-bottom: 5px;
          text-transform: uppercase;
        }
        .upload-contaioner {
          border: 1px solid #5171f3;
          border-radius: 4px;
          background-color: #ffffff;
          height: 265px;
          border-style: dashed;
          margin-right: 15px;
          position: relative;
          input[type="file"] {
            position: absolute;
            height: 36px;
            width: 136px;
            opacity: 0;
            cursor: pointer;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            -ms-transform: translate(-50%, -50%); /* IE 9 fix */
            z-index: 1;
          }
          .upload-button {
            height: 36px;
            width: 136px;
            border-radius: 4px;
            background-color: #51a3f3;
            margin: 0;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
    .email-input {
      margin-bottom: 20px;
    }
    .password-input {
      margin-bottom: 30px;
    }
    .first {
      margin-bottom: 30px;
      .remember-me {
        display: flex;
        align-items: center;
        input {
          margin-right: 5px;
        }
      }
    }
  }
}
@media (min-width: 400px) {
  .wrapper-buttons{
    display: flex;
    align-items: center;
    width: fit-content;
    .primary-button {
      height: 40px;
      width: 140px;
    }
    .secondary-button {
      height: 40px;
      width: 90px;
      margin-right: 20px;
    }
  }

}
@media (max-width:400px ) {
  .marg_left{
    margin-top: 10px;

  }
}
</style>